// i18n — IKKI QATLAMNING IKKINCHISI.
//
// antd komponentlari o'z matnlarini `ConfigProvider locale` dan oladi.
// Buni o'rnatmasak, o'zbekcha ilovada bo'sh joy tagida inglizcha "No data"
// qolib ketadi — abonent buni ANIQ ko'radi (masalan hali paket sotib
// olmagan bo'lsa, "Sessiyalar" bo'sh jadval bilan boshlanadi).

import type { Locale } from 'antd/es/locale'
import enUS from 'antd/locale/en_US'
// antd'da dariy locale yo'q — `fa_IR` ishlatiladi. Ichki matnlar
// (OK, Bekor qilish, oy nomlari) ikkala shevada ham bir xil.
import faIR from 'antd/locale/fa_IR'
import ruRU from 'antd/locale/ru_RU'
import uzUZ from 'antd/locale/uz_UZ'
import type { Language } from './index'

export const ANTD_LOCALES: Record<Language, Locale> = {
  en: enUS,
  fa: faIR,
  ru: ruRU,
  uz: uzUZ,
}
